import { GET_AVATAR_BY_CONTACT_ID_API_ROUTE } from "./../../../contact/~api/apiRoutes"

export const GetContactAvatarLink = (id: string | null) : string => {
    return !id ?
            '' :
            GET_AVATAR_BY_CONTACT_ID_API_ROUTE + id + "&rand=" + Math.random();
}